import { FormattedWorkflowConfiguration } from "@idw-types/data/workflow-configuration";

export enum WorkflowsActionTypes {
    // Workflows
    SET_WORKFLOW_CONFIGURATIONS_LOADING = "SET_WORKFLOW_CONFIGURATIONS_LOADING",
    SET_WORKFLOW_CONFIGURATIONS = "SET_WORKFLOW_CONFIGURATIONS",
    REPLACE_WORKFLOW_CONFIGURATION = "REPLACE_WORKFLOW_CONFIGURATION",
    REMOVE_WORKFLOW_CONFIGURATION = "REMOVE_WORKFLOW_CONFIGURATION"
}

// Workflows
type SetWorkflowConfigurationsLoadingAction = {
    type: WorkflowsActionTypes.SET_WORKFLOW_CONFIGURATIONS_LOADING,
    payload: { isLoading: boolean; }
};

export const setWorkflowConfigurationsLoading = (isLoading: boolean): SetWorkflowConfigurationsLoadingAction => ({
    type: WorkflowsActionTypes.SET_WORKFLOW_CONFIGURATIONS_LOADING,
    payload: { isLoading }
});

type SetWorkflowConfigurationsAction = {
    type: WorkflowsActionTypes.SET_WORKFLOW_CONFIGURATIONS,
    payload: { workflowConfigurations: Array<FormattedWorkflowConfiguration>; }
}

export const setWorkflowConfigurations = (workflowConfigurations: Array<FormattedWorkflowConfiguration>): SetWorkflowConfigurationsAction => ({
    type: WorkflowsActionTypes.SET_WORKFLOW_CONFIGURATIONS,
    payload: { workflowConfigurations }
});

type ReplaceWorkflowConfigurationAction = {
    type: WorkflowsActionTypes.REPLACE_WORKFLOW_CONFIGURATION;
    payload: { workflowConfiguration: FormattedWorkflowConfiguration };
};

export const replaceWorkflowConfiguration = (workflowConfiguration: FormattedWorkflowConfiguration): ReplaceWorkflowConfigurationAction => ({
    type: WorkflowsActionTypes.REPLACE_WORKFLOW_CONFIGURATION,
    payload: { workflowConfiguration }
});

type RemoveWorkflowConfigurationAction = {
    type: WorkflowsActionTypes.REMOVE_WORKFLOW_CONFIGURATION;
    payload: { workflowConfiguration: FormattedWorkflowConfiguration };
};

export const removeWorkflowConfiguration = (workflowConfiguration: FormattedWorkflowConfiguration): RemoveWorkflowConfigurationAction => ({
    type: WorkflowsActionTypes.REMOVE_WORKFLOW_CONFIGURATION,
    payload: { workflowConfiguration }
});

export type WorkflowsActions =
    // Workflows
    SetWorkflowConfigurationsLoadingAction |
    SetWorkflowConfigurationsAction |
    ReplaceWorkflowConfigurationAction |
    RemoveWorkflowConfigurationAction